export default __webpack_public_path__ + "static/media/logo-white-1.603d6967.svg";